interface Props {
	className?: string;
	html: string;
}
export default function PromptDescription({ className, html }: Props) {
	return (
		<div
			className={`ProseMirror ${className}`}
			dangerouslySetInnerHTML={{
				__html: html ?? "",
			}}></div>
	);
}
